<template>
 <section class="hero">
    <div class="hero-body">
      <div class="container">
        <h1 class="title">
                Stati videogame
        </h1>
        <b-tabs v-model="selectedTab">
            <b-tab-item label="Tabella">
              <div style="cursor:pointer">
              <b-table :data="rowData" :columns="columns"
                  :striped=true
                  :paginated="true"
                  :per-page="15"
                  :pagination-simple="false"
                  :selected.sync="selected"
                  @select="select"
                  @click="rowClicked"
                  >
                <b-input
                  slot="searchable"
                  slot-scope="props"
                  v-model="props.filters[props.column.field]"
                  placeholder="Cerca..."
                  icon="magnify"
                  size="is-small" 
                />
              </b-table>
              </div>
               <section>
                  <div class="buttons">
                    <b-button @click="doNew" type="is-primary" >Nuovo</b-button>
                  </div>
                </section>
            </b-tab-item>

            <b-tab-item label="Azioni" disabled>
            <div class="column is-half" ref="form">
                <section >
                  <span v-if="newItem.Id" class="subtitle">Id: {{newItem.Id}}</span>
                <b-field label="Stato">
                   <b-input ref="input1" v-model="newItem.GameStatus" required validation-message="Scrivi qualcosa!" ></b-input>
                </b-field>   
                
                <div class="field">
                  <b-checkbox v-model="newItem.Active">Attivo</b-checkbox>
                </div>
                <b-field label="Timeline">
                  <b-select ref="iStatus" v-model="newItem.Timeline" required validation-message="Obbligatorio!">
                    <option >
                      past
                    </option>
                    <option >
                      present
                    </option>
                    <option >
                      future
                    </option>
                  </b-select>
                </b-field> 
                </section>
                <section>
                  <div class="buttons">
                    <b-button @click="doEdit" type="is-primary" >Salva</b-button>
                    <b-button @click="doDelete" v-show="newItem.Id!=0" type="is-dark">Scancella</b-button>
                  </div>
                </section>
              </div>
            </b-tab-item>
          </b-tabs>
      </div>
    </div>
  </section>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = {Id: 0, GameStatus:"" , Active:true, IsSeason: true};

export default {
  name: 'GameStatus',
  methods: {
    doDelete() {
      this.$buefy.dialog.confirm({
        message: 'Lo scancello sul serio?',
        onConfirm: () => {
          const loading = this.$buefy.loading.open();
          api.gameStatus.delete(this.newItem.Id) 
            .then (()=>{
              return api.gameStatus.getAll()
            })
            .then ((rows)=>{
              this.rowData = rows.data;
              this.$store.state.modes = rows.data;
              helpers.ok('Stato correttamente scancellato');
              this.newItem = emptyVal;
              this.selectedTab = 0;
              loading.close();
            })
            .catch (()=> {
              helpers.error("PS: non è che ci sono giochi con questa voce? Inattiva!");
              loading.close();
            })
        }
    })
    },
    doNew() {
      this.newItem = emptyVal;
      this.selectedTab = 1;
    },

    doEdit() {
    
      let apiMethod = this.newItem.Id!=0?api.gameStatus.update:api.gameStatus.create;
      const loading = this.$buefy.loading.open();
      apiMethod(this.newItem)
      .then (()=>{
        return api.gameStatus.getAll() 
      })
      .then ((rows)=>{
          this.rowData = rows.data;
          this.$store.state.modes = rows.data;
          helpers.ok('Stato correttamente salvato');
          this.newItem = emptyVal;
          this.selectedTab = 0;
          loading.close();
      })
      .catch ((err)=> {
        helpers.error("Errore! " + err)
        loading.close();
      })
      
    },
    rowClicked(row) {
      if (row.Id==this.newItem.Id) {
         this.selected = null;
         this.newItem = emptyVal;
       }else {
         this.selectedTab=1;
       }
        
    },
    select(row) {
       this.newItem = row;
    }    
  },
  data() {
        return {
            selectedRow: null,
            newItem: emptyVal,
            rowData: [],
            selected: null,
            selectedTab: 0,
            columns: [
                {
                    field: 'Id',
                    label: 'id',
                    width: '40',
                    numeric: true
                },
                {
                    field: 'GameStatus',
                    label: 'Stato',searchable: true,
                    sortable: true
                },
                 {
                    field: 'Active',
                    label: 'Attivo',
                },
                {
                  field: 'Timeline',
                  label: 'Timeline',
                }
            ]
        }
    },
    mounted() {
      const loading = this.$buefy.loading.open();
        api.gameStatus.getAll()
        .then ((rows)=>{
          this.rowData = rows.data;
          this.$store.state.GameStatuses = rows.data;
          loading.close();
        })
    }
}
</script>

<style>

</style>